export default __webpack_public_path__ + "static/media/logo-blue.8f018a88.svg";